import { Component, Input, OnInit } from '@angular/core';

import { faExclamationTriangle } from '@fortawesome/pro-solid-svg-icons';

import { NavigationService } from '../../core/services/navigation.service';

@Component({
  selector: 'dx-page-error',
  templateUrl: './page-error.component.html',
  styleUrls: ['./page-error.component.scss']
})
export class PageErrorComponent implements OnInit {
  @Input() status: number;
  faExclamationTriangle = faExclamationTriangle;

  constructor(private navigationService: NavigationService) { }

  get reloadUrl() {
    return this.navigationService.currentUrlPath || '/';
  }

  ngOnInit() {
  }
}
